import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'not-found',
    template: '<h1>Not found component</h1>'
})

export class NotFoundComponent implements OnInit{
    constructor(
        private route: ActivatedRoute,
        private router: Router
      ) {}
  ngOnInit() {
  }

}
